<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table">
  <ng-container matColumnDef="bankAccountNumber">
    <th mat-header-cell *matHeaderCellDef> Overeenkomstnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.bankAccountNumber ? data.bankAccountNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> Product </th>
    <td mat-cell *matCellDef="let data"> {{data.name ? data.name : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="lifeCycleStatus">
    <th mat-header-cell *matHeaderCellDef> Status </th>
    <td mat-cell *matCellDef="let data"> {{data.lifeCycleStatus ? data.lifeCycleStatus : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="authorizations">
    <th mat-header-cell *matHeaderCellDef> Autorisatie </th>
    <td mat-cell *matCellDef="let data"> {{data.authorizations.length !== 0 ? data.authorizations : emptyValuePlaceholder}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
